import { defineTour } from '@lopettia/simul';

/**
 * Coach (Sales Manager) — pipeline → forecast → demo analytics → demo
 * conversion by rep. Mirrors docs/manuals/02-sales-manager.md.
 */
export const salesManagerTour = defineTour({
  name: 'Coach pipeline review',
  description:
    'The weekly pipeline + demo-conversion review every sales manager runs '
    + 'with their team.',
  steps: [
    {
      id: 'sm-pipeline',
      kind: 'info',
      target: '[data-tour-id="nav-portfolio"]',
      prelude: { goto: '/portfolio' },
      message:
        '**Coach view.** The portfolio is your team pipeline grouped by '
        + 'campaign and stage.',
      advanceOn: 'manual',
      spotlight: true,
    },
    {
      id: 'sm-forecast',
      kind: 'navigate',
      target: '[data-tour-id="nav-analytics"]',
      toUrl: '/analytics',
      message: 'Open **Analytics** for the rolling forecast.',
      advanceOn: 'navigate',
    },
    {
      id: 'sm-demo-analytics',
      kind: 'navigate',
      target: '[data-tour-id="nav-demo-analytics"]',
      toUrl: '/demos/analytics',
      message:
        'Then open **Demo analytics** — funnel from invite to closed-won, '
        + 'broken down by demo template and pre-sales owner.',
      advanceOn: 'navigate',
    },
    {
      id: 'sm-conv-by-rep',
      kind: 'info',
      target: '[data-tour-id="demo-conversion-by-rep"]',
      message:
        'The **conversion by rep** table is your weekly coaching prompt: '
        + 'who is asking for demos, who is closing on them, who needs help.',
      advanceOn: 'manual',
    },
  ],
});

export default salesManagerTour;
